import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NavState {
    open: boolean;
}

const initialState: NavState = {
    open: false,
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.open = payload;
        },
    },
});

export const { setOpen } = navigationSlice.actions;
export const navSelector = (state: { navigation: NavState }) =>
    state.navigation;
export default navigationSlice.reducer;
